export const roLocale = {
	months: [
		"Ianuarie",
		"Februarie",
		"Martie",
		"Aprilie",
		"Mai",
		"Iunie",
		"Iulie",
		"August",
		"Septembrie",
		"Octombrie",
		"Noiembrie",
		"Decembrie",
	],
	monthsShort: ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Noi", "Dec"],
	weekdays: ["Duminică", "Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă"],
	weekdaysShort: ["Dum", "Lun", "Mar", "Mie", "Joi", "Vin", "Sâm"],
	weekdaysMin: ["Du", "Lu", "Ma", "Mi", "Jo", "Vi", "Sâ"],
	longDateFormat: {
		LT: "HH:mm",
		LTS: "HH:mm:ss",
		L: "DD.MM.YYYY",
		LL: "D MMMM YYYY",
		LLL: "D MMMM YYYY HH:mm",
		LLLL: "dddd, D MMMM YYYY HH:mm",
	},
	calendar: {
		sameDay: "[Astăzi la] LT",
		nextDay: "[Mâine la] LT",
		nextWeek: "dddd [la] LT",
		lastDay: "[Ieri la] LT",
		lastWeek: "[Ultima] dddd [la] LT",
		sameElse: "L",
	},
	relativeTime: {
		future: "în %s",
		past: "acum %s",
		s: "câteva secunde",
		ss: "%d secunde",
		m: "un minut",
		mm: "%d minute",
		h: "o oră",
		hh: "%d ore",
		d: "o zi",
		dd: "%d zile",
		M: "o lună",
		MM: "%d luni",
		y: "un an",
		yy: "%d ani",
	},
	dayOfMonthOrdinalParse: /\d{1,2}\./,
	ordinal: (n: number) => `${n}.`,
	week: {
		dow: 1, // Monday is the first day of the week.
		doy: 4, // The week that contains Jan 4th is the first week of the year.
	},
};
